import { Box } from '@mui/material';
import { Typography } from '../../primitives/typography/typography';

export function ForbiddenPage() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        minHeight: 400,
      }}
    >
      <Typography.Override
        variant="h2"
        sx={{ color: 'primary.main', fontWeight: 600 }}
        gutterBottom
      >
        403
      </Typography.Override>
      <Typography.Heading sx={{ color: 'text.secondary' }}>
        The resource you are trying to access is forbidden.
      </Typography.Heading>
    </Box>
  );
}
